import React from 'react'
import PropTypes from 'prop-types'
import history from 'browserHistory'
import { connect } from 'react-redux'

import { Text, Button } from 'components/base'
import RoutesHelper, { getAbsolutePath } from 'helpers/RoutesHelper'
import { selectors as UserSelectors } from 'data/users'
import { selectors as ConfigSelectors } from 'data/config'
import { createErrorToasterMessage } from 'data/ui/actions'
import { selectors as OrganizationsSelectors } from 'data/organizations'

import CookiesHelpers from 'helpers/Cookies'

class ApplicationEntry extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    photoURL: PropTypes.string.isRequired,
    cookieDomain: PropTypes.string.isRequired,
    organizationId: PropTypes.string.isRequired,
    installationUrls: PropTypes.object.isRequired,
  }

  handleInstallClick = event => {
    event.preventDefault()

    const { id: applicationId, cookieDomain, organizationId } = this.props

    CookiesHelpers.set('integrating-with-orgId', organizationId, {
      domain: cookieDomain,
    })

    window.location.href = getAbsolutePath(
      RoutesHelper.settingsIntegrationInstallApplication({ applicationId })
    )
  }

  handleLearnMoreClick = event => {
    event.preventDefault()

    history.push(
      RoutesHelper.settingsIntegrationApplicationDetails({
        applicationId: this.props.id,
      })
    )
  }

  render() {
    const { name, photoURL } = this.props

    return (
      <section className="application-entry">
        <div
          className="flexbox flexbox-align-center padding-medium background-shade-100 background-shade-50-on-hover radius-large"
          style={{ minWidth: 500 }}
        >
          <img src={photoURL} alt="application logo" height={35} width={35} />
          <div className="flexbox-grow margin-horizontal-medium">
            <Text.Corpus>{name}</Text.Corpus>
          </div>

          <Button.Secondary onClick={this.handleLearnMoreClick}>
            Learn more
          </Button.Secondary>
          <Button.Primary
            className="margin-left-normal"
            onClick={this.handleInstallClick}
          >
            Install
          </Button.Primary>
        </div>
      </section>
    )
  }
}

export default connect(
  state => ({
    userId: UserSelectors.getCurrentUserId(state),
    cookieDomain: ConfigSelectors.getCookieDomain(state),
    organizationId: OrganizationsSelectors.getOrganizationId(state),
  }),
  { createErrorToasterMessage }
)(ApplicationEntry)
